import jwt_decode from 'jwt-decode';
import { all_permissionsRef, company_permissionsRef, setJWT, tokenRef, url, user_permissionsRef } from '../api';
import { setUser } from '../actions/user';
import { initPermission } from './initPermission';

// Slide a live session forward.
//
// A login mints a token that dies in a day, and the check below deletes
// it once that passes - so somebody working across a day boundary lost
// their session on the next REFRESH, which is the worst moment to find
// out because the app had been working until they reloaded. Renewing a
// token that is still valid every time the app boots means a user who
// opens it at least once a week never expires. It cannot renew a dead
// one: the route authenticates like any other, so an expired token is
// refused, and the sign-in is then genuinely required.
//
// Fire and forget. Nothing waits on it, the current token is already
// good, and a failure leaves the session exactly as it was.
const slideSession = (token, Store) => {
  fetch(`${url}/users/refresh-token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  })
    .then((r) => (r.ok ? r.json() : null))
    .then((body) => {
      if (!body || !body.token) return;
      localStorage.setItem(tokenRef, body.token);
      setJWT(body.token);
      try {
        Store.dispatch(setUser(jwt_decode(body.token)));
      } catch (e) { /* the token we already had is still in force */ }
    })
    .catch(() => { /* offline, or the origin is busy - try again next boot */ });
};

export const initUser = Store => {

  if (localStorage.getItem(tokenRef)) {
    setJWT(localStorage.getItem(tokenRef));
    let decoded = null;
    try {
      decoded = jwt_decode(localStorage.getItem(tokenRef));
    } catch (e) {
      // A token we cannot read is a token we cannot use, and throwing
      // here would happen before React renders at all - a blank page
      // rather than a login screen.
      decoded = null;
    }
    if (decoded && new Date().getTime() <= decoded.token_death) {
      Store.dispatch(setUser(decoded));
      initPermission({ Store, decoded });
      slideSession(localStorage.getItem(tokenRef), Store);
    } else {
      localStorage.removeItem(tokenRef);
      localStorage.removeItem(user_permissionsRef);
      localStorage.removeItem(company_permissionsRef);
      localStorage.removeItem(all_permissionsRef);
      localStorage.removeItem('exporters');
    }
  }
};
